(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@shraddhar/web/form-field'), require('@angular/forms'), require('@angular/cdk/platform'), require('@angular/cdk/coercion'), require('@material/switch'), require('@material/ripple'), require('@shraddhar/web/dom'), require('@shraddhar/web/base'), require('@shraddhar/web/ripple')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/switch', ['exports', '@angular/core', '@shraddhar/web/form-field', '@angular/forms', '@angular/cdk/platform', '@angular/cdk/coercion', '@material/switch', '@material/ripple', '@shraddhar/web/dom', '@shraddhar/web/base', '@shraddhar/web/ripple'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.switch = {}), global.ng.core, global.ng.web.formField, global.ng.forms, global.ng.cdk.platform, global.ng.cdk.coercion, global.mdc.switch, global.mdc.ripple, global.ng.web.dom, global.ng.web.base, global.ng.web.ripple));
}(this, (function (exports, core, formField, forms, platform, coercion, _switch, ripple, dom, base, ripple$1) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MDC_SWITCH_CONTROL_VALUE_ACCESSOR = {
        provide: forms.NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MdcSwitch; }),
        multi: true
    };
    /** Change event object emitted by MdcSwitch. */
    var MdcSwitchChange = /** @class */ (function () {
        function MdcSwitchChange(
        /** The source MdcSwitch of the event. */
        source, 
        /** The new `checked` value of the switch. */
        checked) {
            this.source = source;
            this.checked = checked;
        }
        return MdcSwitchChange;
    }());
    var nextUniqueId = 0;
    var MdcSwitch = /** @class */ (function (_super) {
        __extends(MdcSwitch, _super);
        function MdcSwitch(_changeDetectorRef, ripple, elementRef, _parentFormField) {
            var _this = _super.call(this, elementRef) || this;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.ripple = ripple;
            _this.elementRef = elementRef;
            _this._parentFormField = _parentFormField;
            _this._uniqueId = "mdc-switch-" + ++nextUniqueId;
            _this._initialized = false;
            _this.id = _this._uniqueId;
            _this.name = null;
            _this.tabIndex = 0;
            /** The value attribute of the native input element */
            _this.value = null;
            _this._checked = false;
            _this._disabled = false;
            _this._required = false;
            /** Used to set the aria-label attribute on the underlying input element. */
            _this.ariaLabel = null;
            /** Used to set the aria-labelledby attribute on the underlying input element. */
            _this.ariaLabelledby = null;
            _this.change = new core.EventEmitter();
            /** View to model callback called when value changes */
            _this._onChange = function (_) { };
            /** View to model callback called when control has been touched */
            _this._onTouched = function () { };
            _this._root = _this.elementRef.nativeElement;
            if (_this._parentFormField) {
                _parentFormField.elementRef.nativeElement.classList.add('mdc-form-field');
            }
            return _this;
        }
        Object.defineProperty(MdcSwitch.prototype, "checked", {
            get: function () {
                return this._checked;
            },
            set: function (value) {
                if (this.disabled) {
                    return;
                }
                this._checked = coercion.coerceBooleanProperty(value);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSwitch.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this.setDisabledState(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSwitch.prototype, "required", {
            get: function () {
                return this._required;
            },
            set: function (value) {
                this._required = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSwitch.prototype, "inputId", {
            get: function () {
                return (this.id || this._uniqueId) + "-input";
            },
            enumerable: true,
            configurable: true
        });
        MdcSwitch.prototype.getDefaultFoundation = function () {
            var _this = this;
            // Do not initialize foundation until ngAfterViewInit runs
            if (!this._initialized) {
                return undefined;
            }
            var adapter = {
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                setNativeControlChecked: function (checked) { return _this._getInputElement().checked = checked; },
                setNativeControlDisabled: function (disabled) { return _this._getInputElement().disabled = disabled; },
                setNativeControlAttr: function (attr, value) { return _this._getInputElement().setAttribute(attr, value); }
            };
            return new _switch.MDCSwitchFoundation(adapter);
        };
        MdcSwitch.prototype.ngAfterViewInit = function () {
            var _this = this;
            this._initialized = true;
            this.ripple = this._createRipple();
            this.ripple.init();
            this._asyncBuildFoundation()
                .then(function () {
                _this._foundation.init();
                _this.setDisabledState(_this._inputElement.nativeElement.disabled);
            });
        };
        MdcSwitch.prototype.ngOnDestroy = function () {
            this.ripple.destroy();
            this.destroy();
        };
        MdcSwitch.prototype._asyncBuildFoundation = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this._foundation = this.getDefaultFoundation();
                    return [2 /*return*/];
                });
            });
        };
        MdcSwitch.prototype.onChange = function (evt) {
            evt.stopPropagation();
            this._foundation.handleChange(evt);
            this._checked = this._inputElement.nativeElement.checked;
            this._foundation.setChecked(this._checked);
            this._emitChangeEvent();
            this._changeDetectorRef.markForCheck();
        };
        MdcSwitch.prototype.onInputClick = function (evt) {
            evt.stopPropagation();
        };
        MdcSwitch.prototype.onBlur = function () {
            this._onTouched();
        };
        MdcSwitch.prototype.writeValue = function (value) {
            this.checked = !!value;
        };
        MdcSwitch.prototype.registerOnChange = function (fn) {
            this._onChange = fn;
        };
        MdcSwitch.prototype.registerOnTouched = function (fn) {
            this._onTouched = fn;
        };
        /** Toggles the checked state of the switch. */
        MdcSwitch.prototype.toggle = function () {
            this.checked = !this.checked;
            this._onChange(this.checked);
        };
        MdcSwitch.prototype.setDisabledState = function (disabled) {
            var _a;
            var newValue = coercion.coerceBooleanProperty(disabled);
            if (newValue !== this._disabled) {
                this._disabled = newValue;
                (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.setDisabled(newValue);
                this._changeDetectorRef.markForCheck();
            }
        };
        MdcSwitch.prototype.focus = function () {
            this._inputElement.nativeElement.focus();
        };
        MdcSwitch.prototype._createRipple = function () {
            var _this = this;
            var rippleSurface = this.thumbUnderlay.nativeElement;
            var adapter = __assign(__assign({}, ripple$1.MdcRipple.createAdapter(this)), { addClass: function (className) { return rippleSurface.classList.add(className); }, computeBoundingRect: function () { return rippleSurface.getBoundingClientRect(); }, deregisterInteractionHandler: function (evtType, handler) {
                    return _this._inputElement.nativeElement.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                }, isSurfaceActive: function () { return dom.matches(_this._inputElement.nativeElement, ':active'); }, isUnbounded: function () { return true; }, registerInteractionHandler: function (evtType, handler) {
                    return _this._inputElement.nativeElement.addEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                }, removeClass: function (className) { return rippleSurface.classList.remove(className); }, updateCssVariable: function (varName, value) { return rippleSurface.style.setProperty(varName, value); } });
            return new ripple$1.MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        /**
         * Emits a change event on the `change` output. Also notifies the FormControl about the change.
         */
        MdcSwitch.prototype._emitChangeEvent = function () {
            this._onChange(this.checked);
            this.change.emit(new MdcSwitchChange(this, this.checked));
        };
        /** Retrieves the DOM element of the component input. */
        MdcSwitch.prototype._getInputElement = function () {
            return this._inputElement.nativeElement;
        };
        /** Retrieves the DOM element of the component host. */
        MdcSwitch.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcSwitch.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-switch',
                        host: {
                            '[id]': 'id',
                            'class': 'mdc-switch',
                            '[class.mdc-switch--checked]': 'checked',
                            '[class.mdc-switch--disabled]': 'disabled',
                            '(focus)': '_inputElement.nativeElement.focus()'
                        },
                        template: "<div class=\"mdc-switch__track\"></div>\r\n<div #thumbUnderlay class=\"mdc-switch__thumb-underlay\">\r\n  <div class=\"mdc-switch__thumb\"></div>\r\n  <input type=\"checkbox\"\r\n    #input\r\n    role=\"switch\"\r\n    class=\"mdc-switch__native-control\"\r\n    [id]=\"inputId\"\r\n    [attr.name]=\"name\"\r\n    [attr.aria-label]=\"ariaLabel\"\r\n    [attr.aria-labelledby]=\"ariaLabelledby\"\r\n    [tabIndex]=\"tabIndex\"\r\n    [disabled]=\"disabled\"\r\n    [required]=\"required\"\r\n    [checked]=\"checked\"\r\n    (blur)=\"onBlur()\"\r\n    (click)=\"onInputClick($event)\"\r\n    (change)=\"onChange($event)\"/>\r\n</div>",
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                        providers: [
                            MDC_SWITCH_CONTROL_VALUE_ACCESSOR,
                            { provide: formField.MdcFormFieldControl, useExisting: MdcSwitch },
                            ripple$1.MdcRipple
                        ]
                    }] }
        ];
        /** @nocollapse */
        MdcSwitch.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef },
            { type: ripple$1.MdcRipple },
            { type: core.ElementRef },
            { type: formField.MdcFormField, decorators: [{ type: core.Optional }] }
        ]; };
        MdcSwitch.propDecorators = {
            id: [{ type: core.Input }],
            name: [{ type: core.Input }],
            tabIndex: [{ type: core.Input }],
            value: [{ type: core.Input }],
            checked: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            required: [{ type: core.Input }],
            ariaLabel: [{ type: core.Input, args: ['aria-label',] }],
            ariaLabelledby: [{ type: core.Input, args: ['aria-labelledby',] }],
            change: [{ type: core.Output }],
            _inputElement: [{ type: core.ViewChild, args: ['input', { static: true },] }],
            thumbUnderlay: [{ type: core.ViewChild, args: ['thumbUnderlay', { static: false },] }]
        };
        return MdcSwitch;
    }(base.MDCComponent));

    var MdcSwitchModule = /** @class */ (function () {
        function MdcSwitchModule() {
        }
        MdcSwitchModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [formField.MdcFormFieldModule],
                        exports: [
                            formField.MdcFormFieldModule,
                            MdcSwitch
                        ],
                        declarations: [MdcSwitch]
                    },] }
        ];
        return MdcSwitchModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_SWITCH_CONTROL_VALUE_ACCESSOR = MDC_SWITCH_CONTROL_VALUE_ACCESSOR;
    exports.MdcSwitch = MdcSwitch;
    exports.MdcSwitchChange = MdcSwitchChange;
    exports.MdcSwitchModule = MdcSwitchModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-switch.umd.js.map
